import { render, staticRenderFns } from "./CustomerSelectComponent.vue?vue&type=template&id=024df1a9"
import script from "./CustomerSelectComponent.vue?vue&type=script&lang=js"
export * from "./CustomerSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports